import { getProtectedInstance } from "../utils/axiosInstance";

//GET EXPENSE REPORT BY COMPANY FOR DOWNLOAD
export const adminEmpExpenseReportService = async (
  fromDate: any,
  toDate: any,
  companyId: string,
  companyName: string
) => {
  const response = await getProtectedInstance().get(
    `/report/company/${companyId}/user?from_date=${fromDate}&to_date=${toDate}&download=true`
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${companyName}EmployeeExpense.csv`);
  document.body.appendChild(link);
  link.click();
};

// //GET EXPENSE REPORT BY COMPANY
// export const adminEmpExpenseReportGetService = async (
//   fromDate: any,
//   toDate: any,
//   companyId: string
// ) => {
//   const response = await getProtectedInstance().get(
//     `/report/company/${companyId}/user?from_date=${fromDate}&to_date=${toDate}`
//   );
//   return response.data;
// };
